import { createSelector } from "@reduxjs/toolkit";

import { ClinicList } from "custom-models/frontLoader";

import { ClinicsState, LabClinicsState } from "../reducers/frontLoaderReducers";

const selectLabClinics = createSelector(
  [
    ({ clinics }: { clinics: ClinicsState }) => clinics,
    ({ labClinics }: { labClinics: LabClinicsState }) => labClinics,
  ],
  (clinics, labClinics) => {
    return labClinics?.length && clinics
      ? labClinics
          .map((id) => clinics[id])
          .filter((clinic) => clinic)
          .reduce((acc: { [key: number]: ClinicList }, prev: ClinicList) => {
            return { ...acc, [prev.id]: prev };
          }, {})
      : [];
  }
);

export type MemoizedLabStain = ReturnType<typeof selectLabClinics>[0];

export default selectLabClinics;
